export enum DraftType {
  CHANGE_OF_OWNERSHIP = 'CHANGE_OF_OWNERSHIP',
}

export enum DraftInitiator {
  CLIENT = 'client',
  CREW = 'crew',
}

export enum CommunicationChannel {
  WEB = 'WEB',
  MAIL = 'MAIL',
  PHONE = 'PHONE',
  BATCH = 'BATCH',
}

export enum DraftStatus {
  READY_FOR_CLIENT = 'READY_FOR_CLIENT',
  INTERNAL_ONLY = 'INTERNAL_ONLY',
}

export enum ExperienceType {
  NONE = 'NONE',
  MULTI_INHERITANCE = 'MULTI_INHERITANCE',
  UGMA_UTMA = 'UGMA_UTMA',
}
